<template>
  <b-modal
    id="new-delete-employee-platform"
    ref="modal"
    header-class="headerModal"
    centered
    :title="`${$t('Delete')}: ${employeeName?.employeeName}`"
    size="l"
    hide-footer
    @close="onCancel"
  >
    <div style="display: grid; grid-template-columns: repeat(2, 1fr); gap: 10px;">
      <b-form-group
        :label="$t('Platform')"
      >
        <b-form-input
          v-model="platformName"
          disabled
        />
      </b-form-group>
      <b-form-group
        :label="$t('Filiale')"
      >
        <b-form-input
          v-model="storeName"
          disabled
        />
      </b-form-group>
    </div>
    <p style="margin-top:10px;margin-bottom: 0px;font-weight: 600;color:red;">
      {{ $t('AreYouSureForRemoving') }}
    </p>
    <div
      style="margin-top: 5px;"
    >
      <b-button
        type="button"
        variant="none"
        class="buttonSubmit"
        @click="onSubmit"
      >
        {{ $t("Submit") }}
      </b-button>
      <b-button
        type="button"
        variant="danger"
        class="buttonCancel"
        style="margin-right: 15px"
        @click="onCancel"
      >
        {{ $t("Cancel") }}
      </b-button>
    </div>
  </b-modal>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  components: {
  },
  props: ['platformName', 'employeeName', 'storeName'],
  data() {
    return {
    };
  },
  computed: {
    ...mapGetters([]),
  },
  watch: {
  },
  methods: {
    ...mapActions([]),
    onSubmit() {
      this.$emit('deleteEmployeePlanning', this.employeeName?.employeePlanningId)
      this.onReset();
    },
    onCancel() {
      this.onReset();
    },
    onReset() {
      this.$refs.modal.hide();
    },
  },
};
</script>

      <style lang="scss" scoped>
      </style>
